import { render, staticRenderFns } from "./RequirementInputLabel.vue?vue&type=template&id=3edaf7cc&"
import script from "./RequirementInputLabel.vue?vue&type=script&lang=js&"
export * from "./RequirementInputLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports